export default __webpack_public_path__ + "static/media/checkMarkFailed.6134e461.svg";